<template>
  <div class="page_content share_social_pg fixed_page not_conf page_c">

    <div class="main_section">
      <div class="container">

        <div class="row justify-content-center top_title">
          <div class="col-12 text-center">
            <h1>Bedankt voor het meespelen!</h1>
          </div>

        </div>

        <div class="row mt-4 mt-lg-5 mt-md-5">
          <div class="col-12 text-center">
            <div class="share_socials">
              Deel het op social media met #Prepaidsurprise
            </div>
            <div class="d-flex flex-row justify-content-center share_socials_icons">
              <img src="static/img/millen_images/facebook.svg" @click="this.shareBtn" alt="">
            </div>
          </div>
        </div>

        <div class="row justify-content-center btn_content air_btn">
          <button v-if="this.getAccessToken && pendingCodes.length>0" type="button"
                  class="black_btn  mr-1"
                  @click.prevent="redirectCustomer(pendingCodes[pendingCodes.length==1?0:pendingCodes.length-1].code)">
            Speel opnieuw
          </button>
          <button type="button" class="black_secondary_btn ml-1" @click="this.isLoggedIn">
            Terug naar Prepaid Surprise
          </button>
        </div>

      </div>
    </div>


  </div>

</template>

<script>
  import router from "../router";
  import {mapActions, mapGetters, mapMutations} from "vuex";
  import gameFlow from "../common/mixin/gameFlow";

  export default {
    name: "ExtraSpin",
    data() {
      return {
        pendingCodes: [],
      }
    },
    computed: {
      ...mapGetters([
        'getLoginResponse',
        'getAccountResponse',
        'getAccessToken',
        'getGameFlowState',
      ]),

      console: () => console,
    },
    mixins: [
      gameFlow
    ],
    beforeRouteLeave() {
      this.resetGameState()
    },
    mounted() {
      // Method that when the page is loading will pull user's open codes
      this.loadMyAccount()
        .then(() => {
          this.pendingCodes = this.getAccountResponse.pendingCodes
        })
      // End method
    },
    methods: {
      ...mapMutations([
        'updatePlayGameModal',
        'updateLostCodeModal',
        'updateMsisdn',
        'updateSelectedCodeForRedemption'
      ]),
      ...mapActions([
        'loadMyAccount',
        'redeemCode'

      ]),
      // Method that if the user is logged in will direct him to Account page, otherwise will redirect him to Home page
      isLoggedIn() {
        if (this.getLoginResponse) {
          router.push({name: 'Account'})
        } else {
          router.push({name: 'Home'})
        }
      },
      // End Method
      // Method implemented for facebook posting
      shareBtn() {
        FB.ui({
          display: 'popup',
          method: 'share',
          href: 'https://prepaidsurprise.odido.nl/',
          hashtag: '#Prepaidsurprise'
        }, function (response) {
          if (response && !response.error_message) {
            router.push({name: 'SocialConfirmation'})
          } else {
            console.log(response.error_message);
          }
        });
      },
      // End method
      // Method that takes the last open code of the customer and redirects him to gameOption.js in order to play that code
      redirectCustomer(code) {
        this.updateSelectedCodeForRedemption(code)
        this.redeemCode()
          .then((response) => {
            this.$store.commit('updateGameFlowState', response.data.currentConversationState)
            if (this.getGameFlowState)
              this.loadInfoFromConversation(response)
            this.gameRouting()
          })
      }
      // End method
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ExtraSpin.vue